import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Link} from "react-router-dom";
import ReactTable from "react-table";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import Select from "react-select";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";


export default class HiringTimeTracking extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Dispatch._name, API.RequestType.READ_ALL);
		super(props, model);

		try {
			if (localStorage.getItem('dateHiring')) {
				this.state.filterDate = moment((localStorage.getItem('dateHiring'))).format();
			} else {
				this.state.filterDate = moment(Date.now()).format();
			}
		} catch (e) {
			console.log(e, 'error')
		}
		this.state.dispatchView = localStorage.getItem('dispatchView') ?? 'day';
		this.state.showStartDate = false;
		this.state.showEndDate = false;
		this.state.showDateRange = false;
		moment.tz.setDefault("America/Phoenix");
		const startOfLastWeek = moment().startOf('week').subtract(1, 'week'); // Sunday
		const endOfLastWeek = moment().endOf('week').subtract(1, 'week');     // Saturday

		this.state.start_date = startOfLastWeek.format('YYYY-MM-DD');
		this.state.end_date = endOfLastWeek.format('YYYY-MM-DD');
		this.state.dateRangeFormatted = null;
		if (localStorage.getItem('usersHiringTracking')) {
			this.state.selectedUsers = JSON.parse(localStorage.getItem('usersHiringTracking')) ?? [];
		} else {
			this.state.selectedUsers = [];
		}
		this.state.users = [];
	}

	async componentDidMount() {
		await this.getUsers();
		await this.getDispatch();
	}

	getDispatch = async () => {
		let model = new API.BuildClass(Types.Dispatch._name, API.RequestType.READ);
		this.read = 'GET_ALL';
		model.filter = {
			'role': 9,
			'day': this.state.filterDate,
			'active': this.state.filterActive,
			'selectedUsers': this.state.selectedUsers.map((item) => item.value)
		}
		this.state.filter = model.filter;
		const today = moment(Date.now()).format('YYYY-MM-DD');
		if (this.state.start_date !== today || this.state.end_date !== today) {
			model.filter.start_date = this.state.start_date;
			model.filter.end_date = this.state.end_date;
			this.state.dateRangeFormatted = moment(this.state.start_date).format('dddd MMM D') + ' - ' + moment(this.state.end_date).format('dddd MMM D')
		} else {
			this.state.dateRangeFormatted = null;
		}
		model.search = this.state.search
		this.data = await model.submit(null, this.read);
		let total = this.data.total;
		this.data = this.data.items;
		this.setState({data: this.data, total: total ?? null});
		this.updatePresetsToLocalStorage();
		localStorage.setItem("dateHiring", this.state.filterDate);
	}

	handleUsers = (value) => {
		this.state.selectedChanged = true;
		let users = [];
		if (value) {
			for (let i = 0; i < value.length; i++) {
				users.splice(0, 0, value[i]);
			}
			this.state.selectedUsers = users;
			localStorage.setItem("usersHiringTracking", JSON.stringify(value));
		} else {
			this.state.selectedUsers = [];
			localStorage.setItem("usersHiringTracking", JSON.stringify([]));
		}
		//refreshing the data after passing filters
		this.getDispatch().then();
	}

	getUsers = async () => {
		let model = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		this.read = 'GET_HIRING';
		model.limit = 5000;
		let usersPkeys = this.state.selectedUsers.map((user) => user.value)
		try {
			this.users = await model.submit(null, this.read);
			this.users = Object.keys(this.users).map((key) => this.users[key]);
			this.users = this.users[3];
			let selected = this.users.filter(item => usersPkeys.includes(item.resourceId));
			if (selected.length !== 0) {
				this.state.selectedUsers = this.users.filter(item => usersPkeys.includes(item.resourceId)).map((user) => {
					return {value: user.resourceId, label: user.resourceTitle}
				});
			}
			this.setState({
				users: this.users,
				key: Math.random()
			});

		} catch (error) {
			console.log(error, 'error')
		}
	}


	handleActiveFilter = async (value) => {
		if (value) {
			this.state.filterActive = value.value;
			this.setState({filterActive: value.value});
		}
		await this.getDispatch();
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	handleDateChange = async (name, date) => {
		this.state.filterDate = moment(date).format();
		await this.setState({filterDate: moment(date).format()});
		this.handleToggleModal('showDate');
		await this.getDispatch();
	}

	handleWeekSet = async (week) => {
		let moment_date_start = moment();
		let moment_date_end = moment();
		let moment_day = moment_date_start.day();
		let start, end = null;
		if (week === "last") {
			//last sunday
			start = moment_date_start.subtract(moment_day + 7, "days");
			//last saturday
			end = moment_date_end.subtract(moment_day + 1, "days");
		} else if (week === "this") {
			//last sunday
			start = moment_date_start.subtract(moment_day, "days");
			//last saturday
			end = moment_date_end.add(6 - moment_day, "days");
		}
		await this.setState({
			start_date: start.format('YYYY-MM-DD'),
			end_date: end.format('YYYY-MM-DD')
		});
		await this.getDispatch();
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let columns;
		columns = [
			{
				Header: "User",
				id: "display_name",
				/** @param {Dispatch_Object} obj */
				accessor: obj => obj.DisplayName,
				Cell: (props) => {
					let {original} = props;
					return (
						<span>
							<Link to={`/managers/time_tracking/daily_activities?:${original.User}`}>
								{original.DisplayName}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Start Time",
				id: "start_time",
				/** @param {Dispatch_Object} obj */
				accessor: obj => obj.StartTime !== null ? moment(obj.StartTime).local().format('MM/DD/YYYY h:mm A') : "Not working",
			},
			{
				Header: "End Time",
				id: "end_time",
				/** @param {Dispatch_Object} obj */
				accessor: obj => obj.EndTime === null && obj.StartTime ? 'Still working' : obj.EndTime !== null ? moment(obj.EndTime).local().format('MM/DD/YYYY h:mm A') : "Not working",
			},
			{
				Header: "Total Time",
				id: "total_time",
				/** @param {Dispatch_Object} obj */
				accessor: obj => Math.floor(moment.duration(obj.TotalTime, 'seconds').asHours()) + 'h ' + moment.duration(obj.TotalTime, 'seconds').minutes() + 'm ' + moment.duration(obj.TotalTime, 'seconds').seconds() + 's',
			},
			{
				Header: "Break Time",
				id: "break_time",
				/** @param {Dispatch_Object} obj */
				accessor: obj => Math.floor(moment.duration(obj.BreakTime, 'seconds').asHours()) + 'h ' + moment.duration(obj.BreakTime, 'seconds').minutes() + 'm ' + moment.duration(obj.BreakTime, 'seconds').seconds() + 's',
			},
			{
				Header: "Last Activity",
				id: "last_activity",
				/** @param {Dispatch_Object} obj */
				accessor: obj => obj.LastActivity,
			},
			{
				Header: "Last Activity Time",
				id: "last_activity_time",
				/** @param {Dispatch_Object} obj */
				accessor: obj => obj.LastActivityTime,
			},
			{
				Header: "Avg Time Between Activities",
				id: "avg_call_time",
				/** @param {Dispatch_Object} obj */
				accessor: obj => obj.AvgCallTime,
			},
			{
				Header: "Total Gaps",
				id: "total_gaps",
				/** @param {Dispatch_Object} obj */
				accessor: obj => obj.TotalGaps,
				Cell: (props) => {
					let {original} = props;
					return (
						<span>
							<Link to={`/managers/time_tracking/daily_gaps?:${original.User}`}>
								{original.TotalGaps}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Avg Gap Respond Time",
				id: "avg_gap_time",
				/** @param {Dispatch_Object} obj */
				accessor: obj => obj.AvgGapTime,
			},
			{
				Header: "Books",
				id: "books",
				/** @param {Dispatch_Object} obj */
				accessor: obj => obj.Books,
			},
			{
				Header: "Book %",
				id: "book_percent",
				/** @param {Dispatch_Object} obj */
				accessor: obj => obj.BookPercent,
			},
		];

		return (
			<div className={'box-body'}>
					<div className="table-bar">
						<div className={"rbc-toolbar"}>
							<div>
								<IconButton onClick={async () => {
									const today = moment(Date.now()).format('YYYY-MM-DD');
									this.setState({
										filterDate: moment(this.state.filterDate).subtract(1, 'day').format(),
										dateRangeFormatted: null,
										start_date: today,
										end_date: today
									}, async () => {
										await this.getDispatch();
									})
								}}><LeftArrowIcon/></IconButton>
								<button className="rbc-today" type="button" onClick={async () => {
									const today = moment(Date.now()).format('YYYY-MM-DD');
									this.setState({
										filterDate: moment(Date.now()).format(),
										dateRangeFormatted: null,
										start_date: today,
										end_date: today
									}, async () => {
										await this.getDispatch();
									})
								}}>Today
								</button>
								<IconButton onClick={async () => {
									const today = moment(Date.now()).format('YYYY-MM-DD');
									this.setState({
										filterDate: moment(this.state.filterDate).add(1, 'day').format(),
										dateRangeFormatted: null,
										start_date: today,
										end_date: today
									}, async () => {
										await this.getDispatch();
									})
								}}><RightArrowIcon/></IconButton>
							</div>

							<div className={"rbc-toolbar-label"}>
								<label onClick={() => {
									this.handleToggleModal('showDate')
								}}>
									{this.state.dateRangeFormatted ? this.state.dateRangeFormatted : moment(this.state.filterDate).format('dddd MMM D')}
								</label>
							</div>
							<div className={'col-2'}>
								<Select
									placeholder={"Working/Not Filter"}
									onChange={this.handleActiveFilter}
									options={[
										{value: 'all', label: 'Select All'},
										{value: 'active', label: 'Working'},
										{value: 'not', label: 'Not Working'}
									]}
								/>
							</div>
							<div className={'col-2'}>
								<Select
									key={this.state.users}
									placeholder={"User Select"}
									isMulti
									isClearable
									value={this.state.selectedUsers.map(user => {
										return (
											{value: user.value, label: user.label})
									})}
									onChange={this.handleUsers}
									options={this.state.users.map(user => {
										return (
											{value: user.resourceId, label: user.resourceTitle})
									})}
								/>
							</div>
							<div>
								<Button onClick={() => {
									this.setState({showDateRange: true})
								}}>
									Select Date Range
								</Button>
							</div>
							<div>
								{this.state.total > 0 && <div style={{marginLeft: 15}}>
									<span style={{color: "red"}}>Summed Time:</span>
									<b>{Math.floor(moment.duration(this.state.total, 'seconds').asHours()) + 'h ' + moment.duration(this.state.total, 'seconds').minutes() + 'm ' + moment.duration(this.state.total, 'seconds').seconds() + 's'} </b>
								</div>}
							</div>
							<div style={{display: 'flex', justifyContent: 'flex-end'}}>
								<Button onClick={async () => {
									await this.getDispatch();
								}} size={"sm"} color="primary">
									<i className="fa fa-users"/>Refresh Data
								</Button>
							</div>
						</div>

					</div>
				<ReactTable
					key={this.state.key}
					columns={columns}
					manual // Forces table not to paginate or sort automatically, so we can handle it server-side
					data={data}
					pages={pages} // Display the total number of pages
					loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>

				<Modal
					isOpen={this.state.showDate}
					toggle={() => this.handleToggleModal('showDate')}
					size={"sm"}
					backdrop={true}
					style={{display: "none"}}
				>
					<ModalBody>
						<Framework.Elements.Date
							label={"Custom Date"}
							value={this.state.filterDate}
							update={this.handleDateChange}
							open={this.state.showDate}
							clearable={false}
							cancelLabel={''}
						/>
					</ModalBody>
				</Modal>
				<Modal
					isOpen={this.state.showDateRange}
					toggle={() => this.handleToggleModal('showDateRange')}
					size={"lg"}
					backdrop={true}
				>
					<ModalHeader cssModule={{'modal-title': 'w-100 d-flex justify-content-between'}}>
						<span>
							Select Start and End Date
						</span>
						<span>
							<Button onClick={() => {
								this.handleWeekSet('last')
								this.handleToggleModal('showDateRange')
							}}>
								Last Week
							</Button> &nbsp;&nbsp;&nbsp;
							<Button onClick={() => {
								this.handleWeekSet('this')
								this.handleToggleModal('showDateRange')
							}}>
								This Week
							</Button>
						</span>
					</ModalHeader>
					<ModalBody>
						<div className={'row'}>
							<div className={'col-6'}>
								<div>
									Start Date &nbsp;&nbsp;
									<Button onClick={() => {
										this.handleToggleModal('showStartDate')
									}}>
										{moment(this.state.start_date).format('dddd MMM D')}
									</Button>
								</div>
							</div>
							<div className={'col-6'}>
								<div>
									End Date &nbsp;&nbsp;
									<Button onClick={() => {
										this.handleToggleModal('showEndDate')
									}}>
										{moment(this.state.end_date).format('dddd MMM D')}
									</Button>
								</div>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<Button color={'primary'} onClick={() => {
							this.handleToggleModal('showDateRange')
							this.getDispatch()
						}}>
							OK
						</Button>
						<Button color={'secondary'} onClick={() => {
							const today = moment(Date.now()).format('YYYY-MM-DD');
							this.setState({start_date: today, end_date: today})
							this.handleToggleModal('showDateRange')
						}}>
							Cancel
						</Button>
					</ModalFooter>
				</Modal>
				<Modal
					isOpen={this.state.showStartDate}
					toggle={this.toggleClose}
					size={"sm"}
					backdrop={true}
					style={{display: "none"}}
				>
					<ModalBody>
						<Framework.Elements.Date
							label={"Custom Date"}
							value={this.state.start_date}
							update={(name, date) => {
								if (moment(date).isAfter(moment(this.state.end_date))) {
									alert('Start date may not be after the end date.')
									this.handleToggleModal('showStartDate');
									return;
								}
								this.state.start_date = moment(date).format('YYYY-MM-DD');
								this.handleToggleModal('showStartDate');
							}}
							open={this.state.showStartDate}
							clearable={false}
							cancelLabel={''}
						/>
					</ModalBody>
				</Modal>
				<Modal
					isOpen={this.state.showEndDate}
					toggle={this.toggleClose}
					size={"sm"}
					backdrop={true}
					style={{display: "none"}}
				>
					<ModalBody>
						<Framework.Elements.Date
							label={"Custom Date"}
							value={this.state.end_date}
							update={(name, date) => {
								if (moment(date).isBefore(moment(this.state.start_date))) {
									alert('End date may not be before the start date.')
									this.handleToggleModal('showEndDate');
									return;
								}
								this.state.end_date = moment(date).format('YYYY-MM-DD');
								this.handleToggleModal('showEndDate');
							}}
							open={this.state.showEndDate}
							clearable={false}
							cancelLabel={''}
						/>
					</ModalBody>
				</Modal>
			</div>
		)
	}
}
